import { render, staticRenderFns } from "./challenges.vue?vue&type=template&id=5f47c36c&"
import script from "./challenges.vue?vue&type=script&lang=js&"
export * from "./challenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports